import { baseApi } from "./base.api";

export const excelApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    excelImport: build.mutation({
      query: ({ module, body }) => ({
        url: `/excel/${module}/import`,
        method: "POST",
        body,
      }),
    }),
    excelExport: build.mutation({
      query: ({ module, body = {} }) => ({
        url: `/excel/${module}/export`,
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useExcelImportMutation, useExcelExportMutation } = excelApi;
